export default "__VITE_ASSET__DX1uvuTw__"